import { cva } from '@/styled-system/css';

/**
 * Using grid for the following reasons:
 * - Allows "actions" area to follow data areas in the tab order but appear at the top of the
 * data wrapper visually.
 * - Ensures "dataArea1" can truncate to 1 line if there are one or more action buttons.
 */
export const propertyCardDataWrapperRecipe = cva({
  base: {
    alignContent: 'start',
    display: 'grid',
    gridArea: 'data',
    gridTemplateAreas: `
      "dataArea1 dataArea1 actions"
      "dataArea2 dataArea2 dataArea2"
      "dataArea3 dataArea3 dataArea3"
      "dataArea4 mls-logo mls-logo"
      "dataArea5 dataArea5 dataArea5"
    `,
    gridTemplateColumns: '1fr min-content',
    justifyContent: 'space-between',
    textStyle: 'body-sm',
  },
  variants: {
    appearance: {
      large: {
        columnGap: 'PropertyCard.DataWrapper.large.gap.dataArea1-toIcon',
        paddingInline: 'PropertyCard.DataWrapper.large.padding.horz',
        paddingBlockStart: 'PropertyCard.DataWrapper.large.padding.top',
        paddingBlockEnd: 'PropertyCard.DataWrapper.large.padding.bottom',
      },
      small: {
        columnGap: 'PropertyCard.DataWrapper.small.gap.dataArea1-toIcon',
        paddingInline: 'PropertyCard.DataWrapper.small.padding.horz',
        paddingBlockStart: 'PropertyCard.DataWrapper.small.padding.top',
        paddingBlockEnd: 'PropertyCard.DataWrapper.small.padding.bottom',
      },
      horizontal: {
        columnGap: 'tighter',
        paddingInline: 'PropertyCard.DataWrapper.horizontal.padding.horz',
        paddingBlockStart: 'PropertyCard.DataWrapper.horizontal.padding.top',
        paddingBlockEnd: 'PropertyCard.DataWrapper.horizontal.padding.bottom',
      },
    },
  },
});
